import { render, staticRenderFns } from "./block4.vue?vue&type=template&id=0f661d90&scoped=true&"
import script from "./block4.vue?vue&type=script&lang=js&"
export * from "./block4.vue?vue&type=script&lang=js&"
import style0 from "./block4.vue?vue&type=style&index=0&id=0f661d90&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f661d90",
  null
  
)

export default component.exports